import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { RuleAssistModel } from "../model/assist.model";

@Injectable({
    providedIn: 'root',
  })
  export class AssistService {
    apiUrl = environment.apiUrl + 'ask-blakey';
    constructor(private _httpClient: HttpClient) {}
    
    // Rule Assist
    ruleAssist(data: RuleAssistModel){
        return this._httpClient.post<any>(this.apiUrl, data);
    }
  }